module.exports = __webpack_public_path__ + "img/106.7b81ef1f.jpg";